import React from 'react';
import { Badge, useBreakpointValue } from '@chakra-ui/react';
import { EventStatus } from '../../types/types';

interface EventStatusBadgeProps {
  status: EventStatus;
}

export const getStatusColor = (status: EventStatus): string => {
  switch (status) {
    case EventStatus.ACTIVE:
      return 'green';
    case EventStatus.DISABLED_BY_PROVIDER:
      return 'yellow';
    case EventStatus.DISABLED_BY_SYSTEM:
      return 'red';
    default:
      return 'gray';
  }
};

export const EventStatusBadge: React.FC<EventStatusBadgeProps> = ({ status }) => {
  // Responsive values
  const fontSize = useBreakpointValue({ base: '0.6rem', md: '0.7rem' });
  const variant = useBreakpointValue({ base: 'subtle', md: 'solid' });
  
  return (
    <Badge 
      size="sm" 
      colorScheme={getStatusColor(status)}
      fontSize={fontSize}
      variant={variant}
    >
      {EventStatus[status]}
    </Badge>
  );
};
